import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import { MantineProvider } from "@mantine/core";
import {
  AccountProvider,
  apiRequest,
  MicRecorderProvider,
  theme,
  DoubleSidebarProvider,
  DatadogProvider,
  GlobalProvider
} from "@vojomo-core/shared";
import "./index.css";
import "@mantine/core/styles.css";
import { useEffect, useState } from "react";

export const AppWrapper = () => {
  const [pingData, setPingData] = useState<{
    oAuthDomain: string;
    oAuthId: string;
    oAuthAudience: string;
    version: string;
    svTime: string | Date;
  }>();

  useEffect(() => {
    const fetchData = async () => {
      const data: any = await apiRequest({
        path: "/ping?app_name=admin"
      });

      setPingData(data);
    };

    fetchData();
  }, []);

  if (!pingData) {
    return <></>;
  }

  return (
    <Router>
      <Auth0Provider
        domain={pingData.oAuthDomain}
        clientId={pingData.oAuthId}
        authorizationParams={{
          redirect_uri: `${window.location.origin}`,
          audience: pingData.oAuthAudience,
          prompt: "login",
          scope: "openid profile email offline_access"
        }}
        useRefreshTokens={true}
        useRefreshTokensFallback={true}
      >
        <GlobalProvider pingData={pingData}>
          <AccountProvider appName={"admin"}>
            <DatadogProvider appName={"admin"}>
              <DoubleSidebarProvider>
                <MicRecorderProvider>
                  <MantineProvider theme={theme}>
                    <App />
                  </MantineProvider>
                </MicRecorderProvider>
              </DoubleSidebarProvider>
            </DatadogProvider>
          </AccountProvider>
        </GlobalProvider>
      </Auth0Provider>
    </Router>
  );
};
